(function ($, Drupal, window, once) {
  var initialized;
  var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
  var hostname = window.location.hostname;

  // Error event for technical errors. The HTTP status code is passed from
  // the server via drupalSettings (kwf_dcf module), so we no longer need to
  // re-fetch the current URL just to know whether it returned 4xx/5xx.
  var httpStatus = window.drupalSettings && window.drupalSettings.kwf_dcf && window.drupalSettings.kwf_dcf.http_status;
  if (httpStatus && httpStatus >= 400 && httpStatus < 600 && window.adv_event) {
    adv_event.push(["error", {
      error_action: "displayed",
      error_type: "technical",
      error_code: httpStatus,
    }]);
  }

  var getUrlParameter = (name) => {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  };

  var createCookie = (name, value, days) => {
    var expires;

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
  }

  var getCookie = (name) => {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    return parts.length === 2 ? parts.pop().split(";").shift() : null;
  };

  function getPagePath() {
    var pathArray = window.location.pathname.split("/");
    pathArray.shift();
    if (pathArray[pathArray.length - 1] === "") {
      pathArray.pop();
    }
    var path = pathArray.join(":");

    if (path === "") {
      path = "Home";
    }

    return path;
  }

  /**
   * Make sure the code only runs once.
   *
   * @param settings Drupal settings.
   */
  function init(settings) {
    if (!initialized) {
      initialized = true;
      const privacySettingsLink = document.querySelector(
        "footer ul a.cookie-settings"
      );
      privacySettingsLink && privacySettingsLink.addEventListener("click", function (event) {
        event.preventDefault();
        if (window.Cookiebot) {
          Cookiebot.renew();
        }
      });

      /**
       * Add AdobeID cookie
       */
      // const adobeId = Visitor.getInstance("15E9A2BC56CADCE67F000101@AdobeOrg").appendVisitorIDsTo(hostname);
      // const adobeIdArray = adobeId.split('?adobe_mc');
      // createCookie('adobeId', 'adobe_mc' + adobeIdArray[1], 1);

      /**
       * Send page properties on page load.
       */

      var pageviewProps = settings.kwf_dcf.page;
      pageviewProps.page_name = getPagePath();
      pageviewProps.login_status = "not logged in";
      var form = document.querySelector("form.webform-submission-form");
      if (form && window.location.pathname !== '/') {
        const campagnecodeInput = form.querySelector('input[name="campagnecode_donatie"]');

        Object.assign(pageviewProps, {
          form_name: window.location.pathname.split("/").pop(),
          form_step: "1",
          form_step_name: "step 1",
          form_type: campagnecodeInput && campagnecodeInput.value.trim() !== '' ? 'donation' : '',
        });

        formValidationErrors();
      }

      // Error event for validation errors
      function formValidationErrors() {
        const formInputs = document.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], input[type="number"]');

        formInputs.forEach(element => {
          if (element) {
            element.addEventListener(
              "change",
              function () {
                setTimeout(function() {
                  if (element.getAttribute("aria-invalid") === 'true' && window.adv_event) {
                    adv_event.push(["error", {
                      error_action: "displayed",
                      error_type: "validation",
                      error_message: document.getElementById(element.id + "-error").innerHTML,
                      error_area: element.name
                    }]);
                  }
                }, 500);
              }
            );
          }
        });
      }

      const formSubmittedCookie = getCookie("form_submitted");
      if (formSubmittedCookie) {
        var formProps = JSON.parse(
          unescape(formSubmittedCookie).split("+").join(" ")
        );

        if (pageviewProps.page_name === 'payment:error' || pageviewProps.page_name === 'payment:canceled') {
          Object.assign(pageviewProps, {
            page_section: formProps.page_section,
            form_name: formProps.form_name,
            form_step: "failure",
            form_step_name: "betaling mislukt"
          });
        }
        else if (pageviewProps.page_name === 'payment:success' || pageviewProps.page_name === 'payment:pending') {
          Object.assign(pageviewProps, formProps);

          document.cookie =
            "form_submitted=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        }
        else {
          document.cookie =
            "form_submitted=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        }

      }
      if (settings.kwf_dcf.page.page_name === 'bedankt' && settings.kwf_dcf.page.page_section === 'bedankt') {
        settings.kwf_dcf.page.form_name = 'aanmelden-voor-kwf-nieuws';
        settings.kwf_dcf.page.form_step = 'last';
        settings.kwf_dcf.page.form_step_name = 'confirmation';
      }

      if (settings.kwf_dcf.page.page_name === 'formulier-opzeggen-donatie:confirmation' || settings.kwf_dcf.page.page_name === "donatie-opzeggen-of-wijzigen:je-opzegging-is-verzonden") {
        settings.kwf_dcf.page.form_name = 'donatie-opzeggen-of-wijzigen';
        settings.kwf_dcf.page.form_step = 'last';
        settings.kwf_dcf.page.form_step_name = 'confirmation';
        settings.kwf_dcf.page.page_name = 'doneren:donatie-opzeggen-of-wijzigen:confirmation';
        settings.kwf_dcf.page.page_section = 'doneren';
      }

      if (settings.kwf_dcf.page.page_name === 'pink-ribbon:donatie:doneren') {
        settings.kwf_dcf.page.form_name = 'pinkribbon-doneren';
        settings.kwf_dcf.page.form_step_name = 'landing';
      }

      if (settings.kwf_dcf.page.page_name === 'pink-ribbon:help-mee:nieuwsbrief') {
        settings.kwf_dcf.page.form_name = 'pinkribbon-nieuwsbrief';
        settings.kwf_dcf.page.form_step = '1';
        settings.kwf_dcf.page.form_step_name = 'landing';
        settings.kwf_dcf.page.page_name = 'pink-ribbon:help-mee:nieuwsbrief';
        settings.kwf_dcf.page.page_section = 'pink-ribbon';
      }

      if (settings.kwf_dcf.page.page_name === 'pink-ribbon:help-mee:bedankt') {
        settings.kwf_dcf.page.form_name = 'pinkribbon-nieuwsbrief';
        settings.kwf_dcf.page.form_step = 'last';
        settings.kwf_dcf.page.form_step_name = 'completed';
        settings.kwf_dcf.page.page_section = 'pink-ribbon';
      }

      if (settings.kwf_dcf.page.form_name === 'donatie' || settings.kwf_dcf.page.form_name === 'step') {
        settings.kwf_dcf.page.form_name = 'donatie stepper';
      }

      if (form && (form.getAttribute('data-drupal-selector') === 'webform-submission-stepper-ab-test-add-form' || form.getAttribute('data-drupal-selector') === 'webform-submission-doneren-periodiek-add-form')) {
        settings.kwf_dcf.page.form_name = 'donatie stepper';

        let progressSteps = document.getElementsByClassName('progress-step')

        if (progressSteps) {
          progressSteps.forEach(element => {
            if (element.classList.contains('is-active')) {
              let dataPage = element.getAttribute('data-webform-page');
              if (dataPage === 'page_gegevens') {
                settings.kwf_dcf.page.form_step_name = 'personal details';
                settings.kwf_dcf.page.form_step = '2';
              }

              if (dataPage === 'page_betaling') {
                settings.kwf_dcf.page.form_step_name = 'payment details';
                settings.kwf_dcf.page.form_step = '3';
              }

              if (dataPage === 'webform_confirmation') {
                settings.kwf_dcf.page.form_step_name = 'completed';
                settings.kwf_dcf.page.form_step = 'last';
              }
            }
          })
        }

        let pathAndVariables = (location.pathname+location.search).substring(1);

        if (pathAndVariables.includes('month')) {
          settings.kwf_dcf.page.page_name = 'donatie:maandelijks:' + settings.kwf_dcf.page.form_step_name;
        }

        if (pathAndVariables.includes('year')) {
          settings.kwf_dcf.page.page_name = 'donatie:jaarlijks:' + settings.kwf_dcf.page.form_step_name;
        }
      }

      if (form && form.getAttribute('data-drupal-selector') === 'webform-submission-anonieme-donatie-add-form') {
        settings.kwf_dcf.page.form_name = 'donatie stepper';
        settings.kwf_dcf.page.form_step = '3';
        settings.kwf_dcf.page.form_step_name = 'payment details';
        settings.kwf_dcf.page.page_name = 'donatie:eenmalig:payment details';
      }

      // Add menu navigation from local storage.
      var clickedMenuItemPrevPage = window.localStorage.getItem('clickedMenuItem');
      if (clickedMenuItemPrevPage) {
        settings.kwf_dcf.page.hyperlink_action = 'navigate';
        settings.kwf_dcf.page.hyperlink_name = clickedMenuItemPrevPage;
        settings.kwf_dcf.page.hyperlink_trigger = 'top navigation';
        window.localStorage.removeItem('clickedMenuItem');
      }

      if (window.adv_event) {
        adv_event.push(["pageview", settings.kwf_dcf.page]);
      }

      /**
       * Track menu clicking / page destination.
       */
      window.localStorage.removeItem('clickedMenuItem');
      var menuLinks = document.querySelectorAll('.main-menu a');
      menuLinks.forEach(menuLink => {
        menuLink.addEventListener('click', function () {
          var clickedMenuLinkHref = menuLink;
          if ($(clickedMenuLinkHref).parent().hasClass('menu__level-2')) {
            var parentClickedMenuItem = $(clickedMenuLinkHref).parent().closest('.menu__level-1');
            var parentText = parentClickedMenuItem.children(0);
            var parentLinkText = parentText[0].text.trim();
            var linkTextSendThis = parentLinkText + ':' + clickedMenuLinkHref.text.trim();
            // Set link text + possible parent link text in local storage.
            window.localStorage.setItem('clickedMenuItem', linkTextSendThis.toLowerCase());
          }
          else {
            window.localStorage.setItem('clickedMenuItem', menuLink.text.trim().toLowerCase());
          }
        });
      });

      /**
       * Send download data when clicking on a pdf link.
       */
      $(document).on("click", 'a[href$=".pdf"]', function () {
        var path = $(this).attr("href");
        var download_name = /[^/]*$/.exec(path)[0];
        var download_type = $(this).attr("data-download-type");
        var download_url =
          window.location.protocol + window.location.host + path;

        if (window.adv_event) {
          adv_event.push([
            "download",
            {download_name, download_type, download_url},
          ]);
        }
      });

      /**
       * Send data when clicking on a social link.
       */
      var socialShareLinks = document.querySelectorAll(".share-buttons a");
      socialShareLinks.forEach((link) => {
        link.addEventListener("click", function () {
          if (window.adv_event) {
            adv_event.push([
              "social interaction",
              {
                social_name: this.getAttribute("title"),
                social_action: "share",
                social_url: this.getAttribute("href"),
              },
            ]);
          }
        });
      });

      var socialFollowLinks = document.querySelectorAll(
        'a[data-social-type="follow"]'
      );
      socialFollowLinks.forEach((link) => {
        link.addEventListener("click", function () {
          if (window.adv_event) {
            adv_event.push([
              "social interaction",
              {
                social_name: this.getAttribute("data-social-service"),
                social_action: "follow",
                social_url: this.getAttribute("href"),
              },
            ]);
          }
        });
      });

      /**
       * Send data when submitting a search query.
       */
      var searchResults = document.querySelector(".view-search");
      var search_keyword = getUrlParameter("search_api_fulltext");
      if (searchResults && search_keyword) {
        if (window.adv_event) {
          adv_event.push(["search", {search_keyword}]);
        }

        searchResults.querySelectorAll("a").forEach((searchResult) => {
          searchResult.addEventListener("click", function () {
            if (window.adv_event) {
              adv_event.push([
                "search",
                {
                  search_keyword: getUrlParameter("search_api_fulltext"),
                  search_clickthrough: this.getAttribute("href"),
                },
              ]);
            }
          });
        });
      }


      /**
       * Send form data when clicking on submit button.
       */

        // Dummy pageFormProps
      var pageFormProps = {
          form_name: "doneren",
          form_step: "1.5",  // HARDCODED
          form_step_name: "soft conversie", // HARDCODED
          page_name: "doneren:soft conversie", // HARDCODED :soft conversie
          page_section: "doneren",
          form_contact_consents: "",
          payment_type: "ideal",
          donation_frequency: "eenmalig",
          donation_amount: "18"
        };

      var frequency_dutch = {
        'once': 'eenmalig',
        'month': 'maandelijks',
        'quarter': 'elk kwartaal',
        'year': 'jaarlijks'
      };

      var payment_types = {
        'incasso': 'machtiging',
        'creditcard': 'credit_card',
        'ideal': 'ideal'
      };

      var amountDict = {
        'ik_doneer_eenmalig[radios]': 'edit-ik-doneer-eenmalig-other',
        'frequentie_eenmalig[radios]': 'edit-frequentie-eenmalig-other',
        'eenmalig[radios]': 'edit-eenmalig-other',
        'eenmalig': ''
      };

      var submit = document.getElementById('edit-actions-submit');
      var form = document.getElementsByTagName('form');
      let webform = null;
      form.forEach(function (element) {
        if (element.classList.contains('webform-submission-form')) {
          webform = element;
        }
      })

      if (!submit) {
        var submit = document.getElementById('edit-submit')
      }

      let getElementData = function () {
        //Get the donation frequency input elements and donation amount
        var donation_frequency = document.getElementsByName('frequentie');
        var donation_frequency_eng = document.getElementsByName('frequency');
        if (donation_frequency.length == 0 && donation_frequency_eng.length != 0) {
          donation_frequency_eng.forEach((frequency) => {
            if (frequency.checked) {
              var donationAmount = document.getElementsByName('frequency_' + frequency.value + '[radios]');
              donationAmount.forEach((amount) => {
                if (amount.checked) {
                  if (amount.value == '_other_') {
                    var otherAmount = document.getElementById('edit-frequency-' + frequency.value + '-other');
                    pageFormProps['donation_amount'] = otherAmount.value;
                  } else {
                    pageFormProps['donation_amount'] = amount.value;
                  }

                }
              })
              pageFormProps['donation_frequency'] = frequency_dutch[frequency.value];
            }
          });
        } else if (donation_frequency.length == 0) {
          for (var amountName of Object.keys(amountDict)) {
            var selectAmount = document.getElementsByName(amountName)
            if (selectAmount) {
              selectAmount.forEach((amount) => {
                if (amount.checked) {
                  if (amount.value == '_other_') {
                    var otherAmount = document.getElementById(amountDict[amountName]);
                    pageFormProps['donation_amount'] = otherAmount.value;
                  } else {
                    pageFormProps['donation_amount'] = amount.value;
                  }

                }
              })
            }
          }
        } else {
          donation_frequency.forEach((frequency) => {
            if (frequency.checked) {
              var donationAmount = document.getElementsByName(frequency.name + '_' + frequency_dutch[frequency.value] + '[radios]');
              donationAmount.forEach((amount) => {
                if (amount.checked) {
                  if (amount.value == '_other_') {
                    var otherAmount = document.getElementById('edit-' + frequency.name + '-' + frequency_dutch[frequency.value] + '-other');
                    pageFormProps['donation_amount'] = otherAmount.value;
                  } else {
                    pageFormProps['donation_amount'] = amount.value;
                  }

                }
              })
              pageFormProps['donation_frequency'] = frequency_dutch[frequency.value];
            }
          });
        }

        //Get form name
        if (getPagePath().split(":").length > 1) {
          pageFormProps['form_name'] = getPagePath().split(":")[1];
        } else {
          pageFormProps['form_name'] = getPagePath();
        }

        pageFormProps['page_name'] = pageFormProps['form_name'] + ':soft conversie';
        pageFormProps['login_status'] = 'not logged in';

        if (pageFormProps['form_name'] === 'Home' && pageFormProps['page_section'] === 'doneren' && pageFormProps['form_step'] === '1.5') {
          pageFormProps['form_name'] = 'donatie stepper';
          pageFormProps['page_section'] = 'donatie';
          pageFormProps['form_step'] = '1';
        }

        if (pageFormProps['form_name'] === 'donatie' && pageFormProps['page_section'] === 'doneren' && pageFormProps['form_step'] === '1.5') {
          pageFormProps['form_name'] = 'donatie stepper';
          pageFormProps['page_section'] = 'donatie';
          pageFormProps['form_step'] = '3.5';
        }

        //Get payment type
        if (pageFormProps['donation_frequency'] != 'eenmalig') {
          pageFormProps['payment_type'] = 'machtiging';
        } else {
          var payment_type = document.getElementsByName('betaling');
          payment_type.forEach((type) => {
            if (type.checked) {
              pageFormProps['payment_type'] = payment_types[type.value];
            }
          });
        }

        // Form Consent
        let optins = [];
        optins['email_optin'] = document.getElementsByName('email_optin');
        optins['sms_optin'] = document.getElementsByName('sms_optin');
        optins['phone_optin'] = document.getElementsByName('phone_optin');
        let states = ['nvt', 'ja', 'nee'];


        if (optins['email_optin'].length) {
          if (optins['email_optin'][0].checked) {
            pageFormProps['form_contact_consents'] = pageFormProps['form_contact_consents'] + "email:" + states[1] + "|";
          } else {
            pageFormProps['form_contact_consents'] = pageFormProps['form_contact_consents'] + "email:" + states[2] + "|";
          }
        } else {
          pageFormProps['form_contact_consents'] = pageFormProps['form_contact_consents'] + "email:" + states[0] + "|";
        }

        if (optins['sms_optin'].length) {
          if (optins['sms_optin'][0].checked) {
            pageFormProps['form_contact_consents'] = pageFormProps['form_contact_consents'] + "sms:" + states[1] + "|";
          } else {
            pageFormProps['form_contact_consents'] = pageFormProps['form_contact_consents'] + "sms:" + states[2] + "|";
          }
        } else {
          pageFormProps['form_contact_consents'] = pageFormProps['form_contact_consents'] + "sms:" + states[0] + "|";
        }

        if (optins['phone_optin'].length) {
          if (optins['phone_optin'][0].checked) {
            pageFormProps['form_contact_consents'] = pageFormProps['form_contact_consents'] + "telefoon:" + states[1];
          } else {
            pageFormProps['form_contact_consents'] = pageFormProps['form_contact_consents'] + "telefoon:" + states[2];
          }
        } else {
          pageFormProps['form_contact_consents'] = pageFormProps['form_contact_consents'] + "telefoon:" + states[0];
        }
        // Don't send tracking data (soft conversion) on subscribe to newsletter form submit.
        if (getPagePath() == 'aanmelden-voor-kwf-nieuws' || getPagePath() == 'pink-ribbon:help-mee:nieuwsbrief') {
          return;
        }

        // Don't send tracking data (soft conversion) on stop donation form button click.
        if (getPagePath().split(":").length > 1) {
          var form_name = getPagePath().split(":")[1];
          if (form_name == 'donatie-opzeggen-of-wijzigen') {
            return;
          }
        }

        // Only send event if form is valid.
        let formHasErrors = false;
        setTimeout(function() {
          let formLabels = document.querySelectorAll("#" + webform.id + " label");
          formLabels.forEach((formLabel) => {
            if (formLabel.classList.contains('error')) {
              if (formLabel.getAttribute('style') === 'display: inline;' || formLabel.getAttribute('style') === null) {
                formHasErrors = true;
              }
            }
          });
          if (formHasErrors === false && window.adv_event) {
            adv_event.push(["pageview", pageFormProps]);
          }
        }, 500)
      }

      let delayedSubmit = function (event) {
        // event.preventDefault();
        submit.removeEventListener('click', delayedSubmit);
        getElementData();

        if (isSafari) {
          setTimeout(function () {
            submit.click();
          }, 500);
        }
      }

      if (webform) {
        if (submit) {
          submit.addEventListener('click', delayedSubmit);
        }
      }

      /**
       * Send data when clicking on a button.
       */
      var buttons = document.querySelectorAll(".button--action");
      buttons.forEach((button) => {
        button.addEventListener("click", function () {
          if (window.adv_event) {
            adv_event.push([
              "button click",
              {
                button_name: this.text,
                button_type: "Call to action",
                button_url: this.getAttribute("href"),
              },
            ]);
          }
        });
      });

      /**
       * Send data when playing a video.
       */
      var videos = document.querySelectorAll("script.quadia-player");
      if (0 === videos.length) {
        return;
      }

      (async () => {
        while (!window.QuadiaPlayer || 0 === Object.entries(QuadiaPlayer.players).length) {
          await new Promise((resolve) => setTimeout(resolve, 500));
        }

        videos.forEach((video) => {
          var dataId = video.getAttribute("data-id");

          var Iframe = document.getElementById(dataId);
          QuadiaPlayer.players[dataId].$on("firstFrame", function () {
            var video_id = video.getAttribute("data-video-id");
            var video_name = document
              .querySelector("h1")
              .textContent.replace(/^\s+|\s+$/g, "");
            var video_url = Iframe.getAttribute("src");

            if (window.adv_event) {
              adv_event.push(["video play", {video_id, video_name, video_url}]);
            }
          });
        });
      })();
    }
  }

  Drupal.behaviors.KWFDCHFBehavior = {
    attach: function (context, settings) {
      if (context !== document) {
        return;
      }
      $(once('init-once', context === document ? 'html' : context))
        .each(function initOnce() {
          init(settings);
      });
    },
  };
})(jQuery, Drupal, window, once);
